const comments = [
  {
    id: 1,
    author: "Small Karlo",
    date: "30 October, 2022",
    content:
      "Donec viverra sodales arcu gravida nibh at. Neque lobortis quis porta integer et placerat lectus scelerisque. Velit eget malesuada morbi faucibus at sed euismod. Tortor, eu ut id tincidunt leo placerat luctus",
    imageSrc: "assets/images/thumbnail/01.jpg",
  },
  {
    id: 2,
    author: "Leely Mac",
    date: "30 October, 2022",
    content:
      "Donec viverra sodales arcu gravida nibh at. Neque lobortis quis porta integer et placerat lectus scelerisque. Velit eget malesuada morbi faucibus at sed euismod. Tortor, eu ut id tincidunt leo placerat luctus",
    imageSrc: "assets/images/thumbnail/02.jpg",
  },
  {
    id: 3,
    author: "Racheal Farrera",
    date: "30 October, 2022",
    content:
      "Donec viverra sodales arcu gravida nibh at. Neque lobortis quis porta integer et placerat lectus scelerisque. Velit eget malesuada morbi faucibus at sed euismod. Tortor, eu ut id tincidunt leo placerat luctus",
    imageSrc: "assets/images/thumbnail/03.jpg",
  },
];
export default comments;
